require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin, usePage } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import Store from '@/Store/index'

import moment from 'moment'
// Configure Moment.js to use the desired date format
moment.defaultFormat = 'DD.MM.YYYY';

const el = document.getElementById('app');
el.classList.add('d-flex', 'flex-column', 'h-100');

createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({ methods: { route } })
    .use(Store)
    .use(InertiaPlugin)
    .use(usePage)
    .mount(el);

InertiaProgress.init({ color: '#ffffff' });
